import goTo from '@/libs/functions/goTo'
import { checkPageOauth } from '@/services'

type triggerNodeTypes =
  | 'activtiy'
  | 'section'
  | 'productDetail'
  | 'equityDetail'

export default async function checkOauth(
  triggerNodeCode: string,
  triggerNode: triggerNodeTypes,
  redirect: string,
) {
  const res = await checkPageOauth({
    triggerNodeCode,
    triggerNode,
  })
  // 是否需要授权
  if (res.needAuthorize) {
    goTo(
      `/memberEquity/oauth?triggerNodeCode=${triggerNodeCode}&triggerNode=${triggerNode}&redirect=${encodeURIComponent(
        redirect,
      )}`,
      {
        type: 'replace',
      },
    )
    return Promise.reject()
  } else {
    return Promise.resolve()
  }
}
